// Mesmo critério do contrato do MASTER para a seção e sua contagem.
export const jaRecebeu = item => item.estado === 'ja_recebeu' || (!!item.ultimoEnvio && ['enviada', 'entregue', 'lida'].includes(item.estado))

export const podeReenviar = item => !item.bloqueio && item.podeReenviar === true
